import styled from 'styled-components'

import { media } from 'styles/media'

import WithSelectEscape from '../../../components/SelectEscape/WithSelectEscape'

import SuggestedAdventureCard, { LoadingCard } from './SuggestedAdventureCard'

const Wrapper = styled.div`
  margin: 0 -14px;
  overflow: hidden;
`

const Container = styled.div`
  display: flex;
`

const Slide = styled.div<{ $maxSlides?: number }>`
  padding: 0 14px;
  max-width: 324px;
  box-sizing: border-box;
  flex: 0 0 50%;
  min-width: 0;

  ${media.md`
    flex: 0 0 33.333%;
  `}

  ${({ $maxSlides }) =>
    $maxSlides
      ? `
    @media (min-width: 992px) {
      flex: 0 0 calc(100% / ${$maxSlides});
    }
  `
      : `
    @media (min-width: 992px) {
      flex: 0 0 25%;
    }
  `}
`

interface AdventureCardSliderProps {
  emblaRef: (node: HTMLDivElement | null) => void
  bookingAdventuresIndex: GQL_BookingAdventuresIndex
  bucketListItemsIndex: GQL_BucketListItemsIndex
  adventures: GQL_AdventureCardFragmentFragment[]
  inItineraryContext?: boolean
  maxSlides?: number
  showReviewScore?: boolean
  slideCount: number
}

const AdventureCardSlider = ({
  emblaRef,
  bookingAdventuresIndex,
  bucketListItemsIndex,
  adventures,
  inItineraryContext,
  showReviewScore,
  maxSlides,
  slideCount,
}: AdventureCardSliderProps) => (
  <Wrapper ref={emblaRef}>
    <Container>
      {Array.from({ length: slideCount }, (_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Slide key={i} $maxSlides={maxSlides}>
          {i < adventures?.length ? (
            <WithSelectEscape
              itemId={adventures[i].id}
              itemType="Adventure"
              bookingAdventuresIndex={bookingAdventuresIndex}
              bucketListItemsIndex={bucketListItemsIndex}
            >
              <SuggestedAdventureCard
                {...adventures[i]}
                inItineraryContext={inItineraryContext}
                showReviewScore={showReviewScore}
              />
            </WithSelectEscape>
          ) : (
            <LoadingCard />
          )}
        </Slide>
      ))}
    </Container>
  </Wrapper>
)

export default AdventureCardSlider
